import React from "react";
import ErrorBoundary from "./ErrorBoundary";

/**
 * HOC that wraps a component with ErrorBoundary.
 * @param {React.ComponentType} Component - Component to wrap
 * @param {Object} [options] - ErrorBoundary options
 * @param {boolean} [options.spaLevel=false] - When true, displays full-page style error for app/route-level crashes
 */
function withErrorBoundary(Component, options = {}) {
  const { spaLevel = false } = options;

  const WrapperComponent = React.forwardRef((props, ref) => (
    <ErrorBoundary spaLevel={spaLevel}>
      <Component {...props} ref={ref} />
    </ErrorBoundary>
  ));

  // Preserve the original component's displayName for dev tools.
  WrapperComponent.displayName = `WithErrorBoundary(${Component.displayName || Component.name})`;

  return WrapperComponent;
}

export default withErrorBoundary;
